import type { SessionKanjiResult } from '@kanjido/database'

import type { GroundKanji } from '@/app/_components/ground/load-ground-data'

// Beat 05: Learn complete. The kanji are Lesson 1's real roster; the
// outcomes are a sitting's state, which a visitor has not had, so they are
// a declared fixture: 13 first try, frames 9 and 13 corrected.
const CORRECTED = new Set([9, 13])

// What the completed page derives from those outcomes; firstTryRate is the
// rounded percent the page's leaves print (lib/session-recorder).
export const COMPLETE_STATS = {
    kanjiCount: 15,
    correctCount: 15,
    firstTryRate: 87,
} as const

export function completeFixture(roster: GroundKanji[]): SessionKanjiResult[] {
    return roster.map((k) => {
        const corrected = CORRECTED.has(Number(k.frameNumber))
        return {
            frameNumber: Number(k.frameNumber),
            character: k.character,
            meaning: k.meaning,
            outcome: corrected ? 'corrected' : 'first_try',
            attempts: corrected ? 2 : 1,
            dimension: 'meaning_recognition',
        }
    })
}
